import _typeof from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/typeof";
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
import { PACKAGE_IDS, INDIVIDUAL_PLAN_IDS_WITH_MONTHLY, TEAMS_PLAN_IDS, PLAN_TYPES } from '../constants/plans';
import { sortedTBYBFeaturesMap } from '../constants/featuresMap';
var RecommendedPackagesStrategy = /*#__PURE__*/function () {
  function RecommendedPackagesStrategy(_ref) {
    var packages = _ref.packages,
      addedPaidFeatures = _ref.addedPaidFeatures;
    _classCallCheck(this, RecommendedPackagesStrategy);
    this.packages = packages;
    this.addedPaidFeatures = addedPaidFeatures;
    this.recommendedPackageIds = [];
    this.tbybFeatureMap = {};
    this._loadTBYBFeatureMap();
    this._loadRecommendations();
  }
  _createClass(RecommendedPackagesStrategy, [{
    key: "_loadTBYBFeatureMap",
    value: function _loadTBYBFeatureMap() {
      var _this = this;
      sortedTBYBFeaturesMap.forEach(function (s) {
        // example of s: {wall_logo: create_logo_enabled}
        var tbybKey = Object.keys(s)[0];
        // example: wall_logo -> create_logo_enabled
        _this.tbybFeatureMap[tbybKey] = s[tbybKey];
      });
    }
  }, {
    key: "_loadRecommendations",
    value: function _loadRecommendations() {
      throw new Error('Implementation Required');
    }
  }, {
    key: "isRecommended",
    value: function isRecommended(packageId) {
      return this.recommendedPackageIds.includes(packageId);
    }
  }]);
  return RecommendedPackagesStrategy;
}();
var IndividualRecommendedPackagesStrategy = /*#__PURE__*/function (_RecommendedPackagesS) {
  _inherits(IndividualRecommendedPackagesStrategy, _RecommendedPackagesS);
  var _super = _createSuper(IndividualRecommendedPackagesStrategy);
  function IndividualRecommendedPackagesStrategy() {
    _classCallCheck(this, IndividualRecommendedPackagesStrategy);
    return _super.apply(this, arguments);
  }
  _createClass(IndividualRecommendedPackagesStrategy, [{
    key: "_loadRecommendations",
    value:
    // Find the cheapest package that includes all added paid features.
    function _loadRecommendations() {
      var _this2 = this;
      if (!this.addedPaidFeatures || this.addedPaidFeatures.length === 0) {
        // fall back to advantage package if there is no added paid feature.
        this.recommendedPackageIds.push(PACKAGE_IDS.ADVANTAGE);
        return;
      }
      var minCost = Number.MAX_SAFE_INTEGER;
      var minCostPackageId = 0;
      var candidatePackageIds = INDIVIDUAL_PLAN_IDS_WITH_MONTHLY;
      var packages = this.packages.filter(function (p) {
        return candidatePackageIds.indexOf(p.id) > -1;
      });
      packages.forEach(function (p) {
        var addedPaidFeatureNotIncluded = _this2.addedPaidFeatures.find(function (apf) {
          // example of apf: wall_logo
          var featureLookup = _this2.tbybFeatureMap[apf];
          return featureLookup && p.features[featureLookup] && !p.features[featureLookup].included;
        });
        // if there is no addedPaidFeatureNotIncluded and package's monthly cost is less than current minCost.
        if (!addedPaidFeatureNotIncluded && p.monthly_cost_raw > 0 && p.monthly_cost_raw < minCost) {
          minCost = p.monthly_cost_raw;
          minCostPackageId = p.id;
        }
      });
      this.recommendedPackageIds.push(minCostPackageId);
    }
  }]);
  return IndividualRecommendedPackagesStrategy;
}(RecommendedPackagesStrategy);
var TeamsRecommendedPackagesStrategy = /*#__PURE__*/function (_RecommendedPackagesS2) {
  _inherits(TeamsRecommendedPackagesStrategy, _RecommendedPackagesS2);
  var _super2 = _createSuper(TeamsRecommendedPackagesStrategy);
  function TeamsRecommendedPackagesStrategy() {
    _classCallCheck(this, TeamsRecommendedPackagesStrategy);
    return _super2.apply(this, arguments);
  }
  _createClass(TeamsRecommendedPackagesStrategy, [{
    key: "_loadRecommendations",
    value:
    // Find all packages that include all added paid features.
    function _loadRecommendations() {
      var _this3 = this;
      if (!this.addedPaidFeatures || this.addedPaidFeatures.length === 0) {
        // Do not show recommendation if no added paid feature.
        return;
      }
      var packages = this.packages.filter(function (p) {
        return TEAMS_PLAN_IDS.includes(p.id);
      });
      packages.forEach(function (p) {
        var addedPaidFeatureNotIncluded = _this3.addedPaidFeatures.find(function (apf) {
          // example of apf: wall_logo
          var featureLookup = _this3.tbybFeatureMap[apf];
          return featureLookup && p.features[featureLookup] && !p.features[featureLookup].included;
        });
        if (!addedPaidFeatureNotIncluded) {
          _this3.recommendedPackageIds.push(p.id);
        }
      });
      if (this.recommendedPackageIds.length === packages.length) {
        // If all packages are recommended, do not show recommendations.
        this.recommendedPackageIds = [];
      }
    }
  }]);
  return TeamsRecommendedPackagesStrategy;
}(RecommendedPackagesStrategy);
var getRecommendationStrategyClass = function getRecommendationStrategyClass(_ref2) {
  var displayedPlanType = _ref2.displayedPlanType;
  if (displayedPlanType === PLAN_TYPES.INDIVIDUAL) {
    return IndividualRecommendedPackagesStrategy;
  }
  return TeamsRecommendedPackagesStrategy;
};
export default getRecommendationStrategyClass;